import axios from "axios";

const state = {
  helpMenuContentList: [],
  helpMenuContent: {},
  helpMenuCategoryList: [],
  loading: false
};

const getters = {
  contentList: (state) => state.helpMenuContentList,
  contentData: (state) => state.helpMenuContent,
  helpMenuCategoryList: (state) => state.helpMenuCategoryList,
  loading: (state) => state.loading,

};

const actions = {
  getContentList({ commit }, helpMenuContentPageData) {
    commit('setLoading', true)
    return axios
      .get(
        `/api/panel/help-menu/content-list?page=${helpMenuContentPageData.pageNumber
        }&size=${helpMenuContentPageData.pageSize}`
      )
      .then((response) => {
        commit("setContentList", response.data.payload.items);
        commit('setLoading', false)
        return response.data.payload;
      });
  },
  getHelpMenuCategoryList({ commit }) {
    return axios
      .get(`/api/panel/help-menu/category-select-list`)
      .then((response) => {
        commit("setCategoryList", response.data.payload);
        return response.data.payload;
      });
  },
  getHelpMenuContent({ commit }, id) {
    return axios.get(`/api/panel/help-menu/content/${id}`).then((response) => {
      commit("setContent", response.data.payload);
      return response.data.payload;
    });
  },
  createContent({ commit }, helpMenuContent) {
    return axios
      .post(`/api/panel/help-menu/create-content`, helpMenuContent)
      .then((response) => {
        return response.data;
      });
  },
  updateContentStatus({ commit }, helpMenuContent) {
    let updateStatusData = {
      active: helpMenuContent.active,
    };

    return axios
      .put(
        `/api/panel/help-menu/update-content-status/` + helpMenuContent.id,
        updateStatusData
      )
      .then((response) => {
        return response.data;
      });
  },
  updateContentPriority({ commit }, helpMenuContent) {
    let updatePriorityData = {
      priority: helpMenuContent.priority,
    };

    return axios
      .put(
        `/api/panel/help-menu/update-content-priority/` + helpMenuContent.id,
        updatePriorityData
      )
      .then((response) => {
        return response.data;
      });
  },
  updateContent({ commit }, helpMenuContent) {
    return axios
      .put(`/api/panel/help-menu/update-content`, helpMenuContent)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  deleteContent({ commit }, id) {
    return axios
      .delete(`/api/panel/help-menu/delete-content/` + id)
      .then((response) => {
        return response.data;
      });
  },
};

const mutations = {
  setContentList: (state, contentList) => {
    state.helpMenuContentList = contentList;
  },
  setContent: (state, content) => {
    state.helpMenuContent = content;
  },
  setCategoryList: (state, categoryList) => {
    state.helpMenuCategoryList = categoryList;
  },
  setLoading(state, value) {
    state.loading = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
